import { memo } from 'react';
import type { StackProps } from './BaseStack';
import { BaseStack } from './BaseStack';
import { EffectsStack } from './EffectsStack';

// Cheap gate: when no effects are configured, render the pre-effects path so
// the effects hook, descriptor, and overlay nodes don't exist in the tree.
// Adding/removing the first effect toggles between the two component types —
// acceptable because visual state changes anyway.
function Stack(props: StackProps) {
  const hasEffects = (props.computedBlockState.appearance?.effects?.length ?? 0) > 0;
  return hasEffects ? <EffectsStack {...props} /> : <BaseStack {...props} />;
}

export type { StackProps };
export default memo(Stack);
